import { observable, action } from "mobx";

class GoogleOAuthState {
  @observable inboxId = null;

  @action
  setInboxId = (val = null) => {
    this.inboxId = val;
  };
}

const googleOAuthState = new GoogleOAuthState();

export { googleOAuthState };
export default googleOAuthState;
